module.exports = __webpack_public_path__ + "img/rotate.0b0f1019.svg";